import { faTrashCan as farTrashCan } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faPenToSquare as fasPenToSquare } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@shared/ui/format";
import type { ReactNode } from "react";
import React from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { ButtonLegacy } from "../../ButtonLegacy";

export interface FormIncomeSimpleData {
	incomeType: string;
	incomeTypeName: string;
	amount: number;
	receiptAmount: number;
	incomeStart?: string;
}

interface Props extends FormIncomeSimpleData {
	size?: "sm";
	disabled?: boolean;
	withReceiptAmount?: boolean;
	withIncomeStart?: boolean;
	onDelete: () => void;
	onEdit: () => void;
}

export class SimpleIncomeItem extends React.PureComponent<Props> {
	public render(): ReactNode {
		const {
			incomeTypeName,
			incomeType,
			amount,
			receiptAmount,
			incomeStart,
			disabled,
			withReceiptAmount,
			withIncomeStart,
			size,
			onDelete,
			onEdit,
		} = this.props;

		return (
			<ListGroup.Item>
				<Row>
					<Col className={size === "sm" ? "px-2" : "mb-sm-0 mb-2"} xs={size === "sm" ? 8 : 6}>
						<div className="h6 text-muted text-truncate mb-1">{incomeTypeName || incomeType}</div>
						{withIncomeStart && <div className="d-inline-block income-start">({incomeStart} óta)</div>}
						<div className="font-weight-bold">{formatText(amount, "ft")}</div>
						{withReceiptAmount && <small>Bankhoz érkeztetett: {formatText(receiptAmount, "ft")}</small>}
					</Col>
					<Col className={size === "sm" ? "px-2 text-right" : "text-right"} xs={size === "sm" ? 4 : 6}>
						<ButtonLegacy
							className={size === "sm" ? "ml-2" : "ml-2 mb-2"}
							icon={<FontAwesomeIcon icon={fasPenToSquare} />}
							variant="info"
							size="sm"
							outlined
							disabled={disabled}
							onClick={onEdit}
							children={size === "sm" ? undefined : "Módosítás"}
						/>
						<ButtonLegacy
							className={size === "sm" ? "ml-2" : "ml-2 mb-2"}
							icon={<FontAwesomeIcon icon={farTrashCan} />}
							variant="danger"
							size="sm"
							outlined
							disabled={disabled}
							onClick={onDelete}
							children={size === "sm" ? undefined : "Törlés"}
						/>
					</Col>
				</Row>
			</ListGroup.Item>
		);
	}
}
